var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("minimal-section-heading " + (_vm.selected ? 'selected' : '')),on:{"click":function($event){return _vm.selectSection(_vm.index)}}},[_c('h3',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }